import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-vendor-group-panel',
    templateUrl: './vendor-group-panel.component.html',
    styleUrls: ['./vendor-group-panel.component.scss'],
    standalone: false
})
export class VendorGroupPanelComponent {
  @Input() vendorGroupList: any[] = [];
  @Input() materialSplitGroupList: any[] = [];
  @Input() purchaseOrderObject: any;
  @Input() isSplitedItem: boolean = false;
  @Input() uniqueCodes: string[] = [];
  @Input() currencyMaskOptions: any;
  @Input() allSplitMaterialSelected: boolean = false;
  @Input() purchaseForm!: NgForm;
  @Input() shippmentToggleFn!: (item: any) => void;
  @Input() shippingChargesChangeFn!: (item: any) => void;
  @Input() vendorTaxChangeFn!: (item: any) => void;
  @Input() quoteAmountchangeFn!: (item: any) => void;
  @Input() removeVendorFn!: (item: any, i: any) => void;
  @Input() allSplitMaterialSelectionFn!: (event: any,) => void;
  @Input() selectedSplitMaterialFn!: (event: any, item: any, t: any) => void;
  @Output() splitPO = new EventEmitter<any>();
  @Output() undoSplit = new EventEmitter<any>();
  @Output() selectedSplitMaterial = new EventEmitter<{ event: any, item: any, t: any }>();
  selectedCode: string = '';

    togglePanel(item: any): void {
    // Toggle the expand state for the clicked panel
    item.isExpand = !item.isExpand;

    // Optionally, collapse all other panels if only one should be open at a time
    this.vendorGroupList?.forEach((panel: any) => {
      if (panel !== item) {
        panel.isExpand = false;
      }
    });
  }
  setSplitItemSelect(event: any, vendor: any, material: any){
    if(event){
      this.selectedCode = vendor.uniqueCode;
      vendor.isSplitMaterial = true;
      material.isSplitMaterial = true;
    }else{
      vendor.isSplitMaterial = false;
      material.isSplitMaterial = false;
    }
  }


  undoSplitPO(item: any){
    if(item.materialList.some((m: any) => m.isSplitMaterial)){
    if(this.isSplitedItem){
      this.undoSplit.emit(item.materialList.filter((item: any)=> item.isSplitMaterial));
    }
  }
  }

  checkSplitMaterialChecked(item: any): boolean {
    return item?.materialList?.some((mat: any) => mat.isSplitMaterial);
  }

  getUniqueCodesForVandor(vendor: any): { codes: string[], length: number } {
    const codes = this.vendorGroupList
      .filter((vend: any) => vend.uniqueCode && vend.uniqueCode !== vendor.uniqueCode)
      .map((vendor: any) => vendor.uniqueCode);
    return { codes, length: codes.length };
  }

  vendorExistsInSeparatePO(vendor: any): boolean {
    console.log('vendorGroupList:', this.vendorGroupList);
  return vendor?.some((v: any) => v.uniqueCode);

}

getVendorUniqueCodes(vendorId: number): string[] {
  const vendor = this.vendorGroupList.find((v: any) => v.id === vendorId);
  return vendor
    ? [...new Set<string>(vendor.materialList.map((m: any) => m.uniqueCode))]
    : [];
}

onVendorActionSelect(event: any, vendor: any) {
    this.splitPO.next({target: event.value, selected: vendor.uniqueCode});
}

}
